import React, { useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Modal from "../../components/modal";
import Headline5 from "../../components/headings/Headline5";
import CompanyForm from './companyform';


export type SubskillFormFields = {
//   skills: any;
//   certificationType: any; 
//   percentage: any;
//   ellowScreeningCertifications: {id: string, skills: any; skillRating: number; subSkills: {id: number, name: string}}[];
companyRating: any;
};

interface Props {
  companyRating?: any;
  onClose?: any;
  clickHandler?: any;
  loginId?: any;
  candidateLoginId?: any
  action?: any
  defaultValues?: any
}

const Subskill: React.FC<Props> = ({ onClose, clickHandler, companyRating, loginId, action, defaultValues }) => {
  const validationSchema = Yup.object({});

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const formOptions = {
    resolver: yupResolver(validationSchema),
  };    
  

  
    useEffect(() => {
    //   setUpdatedData(ellowScreeningCertifications && ellowScreeningCertifications[0].subSkills)
    }, [])

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { register, control, handleSubmit, reset, watch } = useForm({
    //   defaultValues: {
    //       subskills: ellowScreeningCertifications
    //   }
    });
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "subskills", // unique name for your Field Array
    });


    const onCloseModal = (e: any) => {
        onClose();
      }

  return (
    <Modal title={" "} onClose={onClose} size="mediumTwo"> 
      <Headline5>New Company</Headline5>
      <form>
         <CompanyForm loginId={loginId}  defaultValues={defaultValues} onClose={onCloseModal} clickHandler={clickHandler} action={action} />
      </form>
    </Modal>
  );
};

export default Subskill;
